// extracted by css-extract-rspack-plugin
export default {"pairContainer":"BOYA9OyQwD05iS5e__pairContainer___","labelSizeSmall":"nM9CwsZgEkMeyfGy__labelSizeSmall___","divider":"E93DFuIsXU1H9Cnv__divider___"};